import React, { useState } from "react";
import SaveButton from "../../../components/Buttons/SaveButton";
import SelectListField from "../../../components/Fields/SelectListField";
import { FormConfig } from "../../../components/Fields/Types";
import useSelectListOptions from "../../../components/Hooks/SelectListOptionsHook/useSelectListOptions";
import useValidation from "../../../components/Hooks/ValidationHook/useValidation";
import Popup from "../../../components/Popups/Popup";
import { useNotifications } from "../../../contexts/notificationContext";
import DataService from "../../../services/data.service";
import { ItemItemRevisionPopupProps } from "../../../types/PopupProps";
import { DataResult } from "../../../types/Result";

interface ProjectItemRevisionModel {
    itemRevisionId: number
    projectId?: number
}

const AddToProjectPopup: React.FC<ItemItemRevisionPopupProps> = ({ show, onHide, itemId, itemRevisionId, itemTypeId }) => {
    const [serverErrors, setServerErrors] = useState<DataResult<ProjectItemRevisionModel>>({ isSuccesful: true, messages: [], data: undefined });
    const { handleResult, handleException } = useNotifications();

    const [formData, setFormData] = useState<ProjectItemRevisionModel>({
        itemRevisionId: itemRevisionId,
    });

    const projects = useSelectListOptions('api/v1/selectlist/Projects?activeOnly=true&itemTypeId=' + itemTypeId, '-- Select project');

    function submit() {
        if (formData) {
            DataService
                .create<ProjectItemRevisionModel>(`api/v1/ProjectItemRevisions`, formData)
                .then(response => {
                    handleResult(response);
                    setServerErrors(response);
                    if (response.isSuccesful === true) {
                        onHide();
                    }
                })
                .catch(e => handleException(e));
        }
    }

    const formConfig: FormConfig = {
        fields: [
            { name: 'projectId', label: 'Project', labelSize: 2, validationRules: [{ type: 'isRequired' }] },
        ],
        handleSubmit: submit,
        showErrors: 'always',
    };

    const { getFieldProps, getSubmitButtonProps } = useValidation(formConfig, formData, serverErrors);

    return (
        <Popup show={show} onHide={onHide} size={'lg'} title={'Add to project'} >
            <Popup.Body>
                <SelectListField {...getFieldProps('projectId')} options={projects} />
            </Popup.Body>
            <Popup.Footer>
                <SaveButton {...getSubmitButtonProps()} text='Add' />
            </Popup.Footer>
        </Popup>
    );
}
export default AddToProjectPopup;